export const getStyles = (theme: any, isCompleted?: boolean) => ({
  styles: {
    button: {
      alignItems: "center",
      backgroundColor: isCompleted
        ? theme.palette.primary.light
        : theme.palette.grey[700],
      border: isCompleted ? "none" : `1px dashed ${theme.palette.grey[600]}`,
      borderRadius: "8px",
      color: theme.palette.grey[0],
      display: "flex",
      height: "72px",
      justifyContent: "center",
      mb: "56px",
      mt: "12px",
      padding: "0 30px",

      "&.MuiButtonBase-root:hover": {
        backgroundColor: isCompleted
          ? theme.palette.primary.light
          : theme.palette.grey[700],
        opacity: 1,
      },
    },
    wrapper: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      width: "100%",
    },
    loader: {
      backgroundColor: theme.palette.grey[600],
      borderRadius: "8px",
      width: "100%",

      "& .MuiLinearProgress-bar": {
        background: theme.palette.grey[0],
      },
    },
    content: {
      display: "flex",
      flexDirection: "column" as "column",
      height: "100%",
      justifyContent: "center",
      marginLeft: "25px",
      width: "100%",
      gap: "2px",
    },
    title: {
      color: theme.palette.grey[0],
      fontSize: "16px",
      margin: 0,
      marginBottom: "2px",
      fontWeight: 500,
      lineHeight: 1.2,
    },
    text: { 
      margin: 0, 
      fontSize: "10px", 
      color: theme.palette.grey[400],
      lineHeight: 1.3,
    },
  },
});
